export type RoomGuestPickerRules = {
  excludedUserId: string | null;
  shouldOfferCurrentUser: boolean;
};

/**
 * Who the room guest picker hides, and whether it offers the current user.
 *
 * The organizer is added to the booking anyway, so they're never offered as a guest. When
 * the organizer is someone else (booking on their behalf), the current user isn't on the
 * booking unless they add themselves, so they're offered first.
 */
export const getRoomGuestPickerRules = ({
  organizerId,
  authUserId
}: {
  organizerId: string | null;
  authUserId: string | undefined;
}): RoomGuestPickerRules => ({
  excludedUserId: organizerId,
  shouldOfferCurrentUser: !!authUserId && organizerId !== authUserId
});
